module.exports = __webpack_public_path__ + "static/media/youtube.0de96162.png";